import React from 'react';
import { WebCalcErrWrapper, WebCalcErrContainer } from './financeModal-stylesRethink';
import { Text, TextButton, Icon } from '@oneaudi/unified-web-components';
import { DangerousElement } from '../../../../../components/DangerousElement';
import { dynamicStylingHelper } from '../../../../utils';
import { useFinanceTranslations } from './finance-i18N';
export const FinanceErrorMessage = ({ webCalcErrorMsg, resetFormOnClick, }) => {
    if (!webCalcErrorMsg) {
        return null;
    }
    const i18n = useFinanceTranslations();
    return (React.createElement(React.Fragment, null,
        React.createElement(WebCalcErrWrapper, null,
            React.createElement(WebCalcErrContainer, null,
                React.createElement(Text, { tag: "p", variant: { type: 'copy', order: '1', style: 'bold' }, className: "web-calc-error-headline" }, i18n === null || i18n === void 0 ? void 0 : i18n.calculationError)),
            React.createElement(WebCalcErrContainer, null,
                React.createElement("div", { style: { marginRight: '12px' } },
                    React.createElement(Icon, { name: "caution", size: "s", "data-testid": "error-icon" })),
                React.createElement("div", null,
                    React.createElement(Text, { tag: "p", variant: { type: 'copy', order: dynamicStylingHelper('2', '3'), style: 'normal' } },
                        React.createElement(DangerousElement, { as: "p", html: webCalcErrorMsg })))),
            React.createElement(TextButton, { "aria-label": i18n === null || i18n === void 0 ? void 0 : i18n.resetButton, icon: "refresh", iconPosition: "leading", onClick: resetFormOnClick, size: "sm", title: i18n === null || i18n === void 0 ? void 0 : i18n.resetButton, variant: "tertiary", "data-test-id": "reset_btn" }, i18n === null || i18n === void 0 ? void 0 : i18n.resetButton))));
};
